<template>
    <a-modal
            :width="'80%'"
            v-model="editEntityTemplate"
            :title="title"
            :maskClosable="maskClosable"
            @ok="handleOk">

        <template slot="footer">
            <span>
                <a-button v-if="!isAddField && !isEditField"  @click="handleCancel">取消</a-button>
                <a-button v-if="!isAddField && !isEditField" type="primary"  @click="handleOk">确定</a-button>
            </span>
        </template>

        <div style="padding:20px;background-color: #f0f2f5">
            <a-card>
                <a-form :form="templateForm">
                    <a-form-item :label="'模板名称'" v-bind="formItemLayout">
                        <a-input size="small" v-model="templateName" v-decorator="['templateName',{ rules: [{ required: true, message: '请输入模板名称!' }] }]"></a-input>
                    </a-form-item>

                    <a-form-item :label="'模板描述'" v-bind="formItemLayout">
                        <a-input size="small" v-model="templateDescription" v-decorator="['templateDescription',{ rules: [{ required: true, message: '请输入模板描述!' }] }]"></a-input>
                    </a-form-item>

                    <a-form-item :label="'模板内容'" :label-col="{span:3}" :wrapper-col="{span:21}">
                        <a-input style="display:none" v-model="tempValue" v-decorator="['tempValue',{ rules: [{ required: true, message: '模板内容不能为空!' }] }]"></a-input>
                        <a-button size="small" type="primary" @click="showAddModel">
                            <a-icon type="plus"/>
                            添加
                        </a-button>

                        <a-table :scroll="{ x: 600 }" borderd :columns="columns" :dataSource="data" style="margin-top:15px" :pagination=false>
                            <template slot="inputType" slot-scope="text">
                                <span v-if="text == 'text'">文本</span>
                                <span v-if="text == 'number'">数字</span>
                                <span v-if="text == 'date'">时间</span>
                                <span v-if="text == 'selectBox'">选择器</span>
                                <span v-if="text == 'image'">上传图片</span>
                            </template>
                            <template slot="capacity" slot-scope="text">
                                {{text ? '是' : '否'}}
                            </template>
                            <template slot="action" slot-scope="text,record,index">
                                <div v-if="isAddField || isEditField">
                                    -
                                </div>
                                <!-- <div v-else>
                                  <a href="javascript:;" @click="upRow(index)">上移</a>
                                  <a-divider type="vertical" />
                                  <a href="javascript:;" @click="downRow(index)">下移</a>
                                  <a-divider type="vertical" />
                                  <a href="javascript:;" @click="onEdit(record)">编辑</a>
                                  <a-divider type="vertical" />
                                  <a-popconfirm
                                          v-if="data.length"
                                          title="确认删除吗?"
                                          @confirm="onDelete(record.name)">
                                      <a href="javascript:;">删除</a>
                                  </a-popconfirm>
                                  <a-divider type="vertical" />
                                </div> -->
                                <a-button-group v-else>
                                  <a-button @click="upRow(index)" :disabled="index === 0 ? true : false">
                                    上移
                                    <zx-icon type="icon-shangyi"></zx-icon>
                                  </a-button>
                                  <a-button @click="downRow(index)" :disabled="index === data.length - 1 ? true : false">
                                    <zx-icon type="icon-xiayi"></zx-icon>
                                    下移
                                  </a-button>
                                  <a-button @click="onEdit(record)">
                                    <zx-icon type="icon-bianji"></zx-icon>
                                    编辑
                                  </a-button>
                                  <a-button @click="onDelete(record.name)">
                                    <zx-icon type="icon-shanchuyihang1"></zx-icon>
                                    删除
                                  </a-button>
                                </a-button-group>
                            </template>
                        </a-table>
                    </a-form-item>
                </a-form>
            </a-card>
        </div>

        <a-form :form="form">
            <div v-show="isAddField || isEditField" style="padding:20px;padding-top:0px;background-color: #f0f2f5" >
                <a-card>
                    <a-form-item :label="'字段名'" v-bind="formItemLayout">
                        <a-input size="small" v-model="name" v-decorator="['name',{ rules: [{ required: true, message: '请输入字段名!' },{validator: validateName,}] }]"></a-input>
                    </a-form-item>

                    <a-form-item :label="'输入类型'" v-bind="formItemLayout">
                        <a-select size="small" v-model="inputType" @change="onTypeChange" >
                            <a-select-option value="text">文本</a-select-option>
                            <a-select-option value="number">数字</a-select-option>
                            <a-select-option value="date">时间</a-select-option>
                            <a-select-option value="selectBox">选择器</a-select-option>
                            <a-select-option value="image">上传图片</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item v-show="inputType == 'selectBox'" :label="'数据来源'" v-bind="formItemLayout">
                        <a-input size="small" v-model="dataSource" placeholder="多个值之间以,分隔" v-decorator="inputType ==  '' ? ['dataSource',{ rules: [{ required: true, message: '请填写数据来源!' }] }] : []"></a-input>
                    </a-form-item>

                    <a-form-item :label="'搜索'" v-bind="formItemLayout">
                        <a-checkbox @change="onTypeChange" v-model="searchable" size="small"></a-checkbox>
                    </a-form-item>

                    <a-form-item v-if="searchable" :label="'搜索方式'" v-bind="formItemLayout">
                        <template v-for="type in searchTypeData">
                            <template>
                                <a-select :key="type.typeName" size="small" v-if="type.typeName == inputType" v-model="searchType">
                                    <a-select-option v-for="item in type.types" :value="item.key" :key="item.key">{{item.label}}</a-select-option>
                                </a-select>
                            </template>
                        </template>
                    </a-form-item>

                    <a-form-item :label="'其他'" v-bind="formItemLayout">
                        <a-col :xl="{span:6}" :sm="{span:12}" :xs="{span:24}">
                            <span style="margin-right:5px">关键属性</span><a-checkbox v-model="isCrucial" size="small" style="margin-right:20px"></a-checkbox>
                        </a-col>
                        <a-col :xl="{span:6}" :sm="{span:12}" :xs="{span:24}">
                            <span style="margin-right:5px">是否必填</span><a-checkbox v-model="isRequire" size="small" style="margin-right:20px"></a-checkbox>
                        </a-col>
                        <a-col :xl="{span:6}" :sm="{span:12}" :xs="{span:24}">
                            <span style="margin-right:5px">是否显示</span><a-checkbox v-model="isShow" size="small" style="margin-right:20px"></a-checkbox>
                        </a-col>
                        <a-col :xl="{span:6}" :sm="{span:12}" :xs="{span:24}">
                            <span style="margin-right:5px">排序</span><a-checkbox v-model="sortable" size="small"></a-checkbox>
                        </a-col>
                    </a-form-item>

                    <a-form-item :wrapper-col="{ span: 12, offset: 3 }">
                        <a-button @click="cancel()" style="margin-right:5px">取消</a-button>
                        <a-button type="primary" @click="confirm">确定</a-button>
                    </a-form-item>
                </a-card>
            </div>
        </a-form>

    </a-modal>
</template>

<script>
    import config from '@/config'

    export default {
        name: 'ZEntityTemplate',
        data() {
            return {
                templateId: null,
                templateName: null,
                templateDescription: null,
                tempValue: null,
                isAddField:false,
                isEditField: false,
                columns: [
                    {
                        title: '字段名',
                        dataIndex: 'name',
                        left: true
                    },
                    {
                        title: '输入类型',
                        dataIndex: 'inputType',
                        scopedSlots: {
                            customRender: "inputType"
                        }
                    },
                    {
                        title: '关键字段',
                        dataIndex: 'isCrucial',
                        scopedSlots: {
                            customRender: "capacity"
                        }
                    },
                    {
                        title: '是否必填',
                        dataIndex: 'isRequire',
                        scopedSlots: {
                            customRender: "capacity"
                        }
                    },
                    {
                        title: '可搜索',
                        dataIndex: 'searchable',
                        scopedSlots: {
                            customRender: "capacity"
                        }
                    },
                    {
                        title: '显示',
                        dataIndex: 'isShow',
                        scopedSlots: {
                            customRender: "capacity"
                        }
                    },
                    {
                        title: '可排序',
                        dataIndex: 'sortable',
                        scopedSlots: {
                            customRender: "capacity"
                        }
                    },
                    {
                        title: "操作",
                        dataIndex: "operation",
                        key: "operation",
                        scopedSlots: {
                            customRender: "action"
                        },
                        right: true
                    }
                ],
                data: [],
                editEntityTemplate: false,
                maskClosable: false,
                title: null,
                name: null,
                inputType: null,
                dataSource: null,
                searchable:false,
                searchType: null,
                isCrucial: false,
                isRequire: false,
                isShow: true,
                sortable:false,
                templateForm: null,
                form: null,
                currentName: null,
                searchTypeData:[
                    {
                        typeName: 'text',
                        types:[
                            {key:'like',label:'模糊匹配'}
                        ]
                    },
                    {
                        typeName: 'number',
                        types:[
                            {key:'compare',label:'比较'}
                        ]
                    },
                    {
                        typeName: 'date',
                        types:[
                            {key:'compare',label:'比较'}
                        ]
                    },
                    {
                        typeName: 'selectBox',
                        types:[
                            {key:'selectBox',label:'选择器'}
                        ]
                    },
                    {
                        typeName: 'image',
                        types:[
                            {key:'image',label:'上传图片'}
                        ]
                    }
                ],
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 3 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 19 },
                    },
                },
                checkBoxItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 12 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 12 }
                    },
                }
            }
        },
        methods:{
          upRow (index) {
            // console.log(index)
            // 将第index行与第index - 1 行进行交换
            let temp = this.data[index]
            this.data[index] = this.data[index - 1]
            this.data[index - 1] = temp
            this.data = [...this.data]
          },
          downRow (index) {
            // console.log(index)
            // 将第index行与第index + 1 行进行交换
            let temp = this.data[index]
            this.data[index] = this.data[index + 1]
            this.data[index + 1] = temp
            this.data = [...this.data]
          },
            validateName(rule, value, callback){
                if(this.isEditField){
                    if(value != this.currentName && this.data.length != this.data.filter(item => item.name != value).length){
                        callback('字段名称已经存在!');
                    }
                }else{
                    if(this.data.length != this.data.filter(item => item.name != value).length) {
                        callback('字段名称已经存在!');
                    }
                }
                callback();
            },
            onDelete(name) {
              let _this = this
              this.$confirm({
                title: '确认删除吗？',
                onOk () {
                  console.log(_this.data)
                  _this.data = _this.data.filter(item => item.name != name)
                }
              })
            },
            onEdit(record) {
                this.currentName = record.name
                this.form.setFieldsValue({
                    name: record.name
                });
                this.name = record.name
                this.inputType = record.inputType
                this.form.setFieldsValue({
                    dataSource: record.dataSource
                });
                this.dataSource = record.dataSource
                this.searchable = record.searchable
                this.searchType = record.searchType
                this.isCrucial = record.isCrucial
                this.isRequire = record.isRequire
                this.isShow = record.isShow
                this.sortable = record.sortable
                this.isEditField = true
            },
            onTypeChange(){
                let _this = this
                this.searchTypeData.map(function(item){
                    if(_this.inputType == item.typeName){
                        _this.searchType = item.types[0].key
                        return
                    }
                })
            },
            confirm(){
                let _this = this
                this.form.validateFieldsAndScroll((err, values) => {
                    if (!err) {
                        if(_this.isAddField){
                            _this.data.push({
                                "name": _this.name,
                                "inputType": _this.inputType,
                                "dataSource": _this.dataSource,
                                "searchable": _this.searchable,
                                "searchType": _this.searchType,
                                "isCrucial": _this.isCrucial,
                                "isRequire": _this.isRequire,
                                "isShow": _this.isShow,
                                "sortable": _this.sortable
                            })
                            _this.isAddField = false
                            _this.templateForm.setFieldsValue({
                                tempValue: _this.data.length == 0 ? null : 'temp',
                            })
                        }else{
                            _this.data.map(function(item){
                                if(item.name == _this.currentName){
                                    item.name = _this.name
                                    item.inputType = _this.inputType
                                    item.dataSource = _this.dataSource
                                    item.searchable = _this.searchable
                                    item.searchType = _this.searchType
                                    item.isCrucial = _this.isCrucial
                                    item.isRequire = _this.isRequire
                                    item.isShow = _this.isShow
                                    item.sortable = _this.sortable
                                }
                            })
                            _this.isEditField = false
                        }
                    }
                });
            },
            handleOk(){
                // console.log(this.templateDescription)
                this.templateForm.setFieldsValue({
                    tempValue: this.data.length == 0 ? null : 'temp',
                });
                let _this = this
                this.templateForm.validateFieldsAndScroll((err, values) => {
                    if (!err) {
                      // console.log(values)
                        let param = {}
                        param.name = this.templateName
                        param.description = this.templateDescription
                        param.attrs = _this.data
                        // console.log(this.templateName)
                        // console.log(this.templateDescription)
                        // console.log(param)
                        if(_this.templateId){
                            param.id = _this.templateId
                            _this.$http.put(config.api.entity_template_url,param).then((response) => {
                                if(response.code == 0){
                                    _this.$message.success('修改模板成功')
                                    _this.$emit('success');
                                    _this.editEntityTemplate = false
                                }
                            }).catch((err) => {
                                console.log(err)
                            })
                        }else{
                            _this.$http.post(config.api.entity_template_url,param).then((response) => {
                                if(response.code == 0){
                                    _this.$message.success('添加模板成功')
                                    _this.$emit('success');
                                    _this.editEntityTemplate = false
                                }
                            }).catch((err) => {
                                console.log(err)
                            })
                        }
                    }
                });
            },
            cancel() {
                this.isAddField = false
                this.isEditField = false
            },
            handleCancel() {
                this.editEntityTemplate = false
            },
            showAddModel(){
                this.form.setFieldsValue({
                    name: null
                });
                this.name = null
                this.inputType = 'text'
                this.form.setFieldsValue({
                    dataSource: null
                });
                this.dataSource = null
                this.searchable = false
                this.searchType = null
                this.isCrucial = false
                this.isRequire = false
                this.isShow = true
                this.sortable = false
                this.isAddField = true
            },
            showModel(template){
                if(template){
                  // console.log(template)
                    this.editEntityTemplate = true
                    this.templateForm = this.$form.createForm(this)
                    this.form = this.$form.createForm(this)
                    let _this = this
                    this.$nextTick().then(() => {
                      this.templateForm.setFieldsValue({
                        templateName: template.name,
                        templateDescription: template.description
                      })
                    })
                    this.templateName = template.name
                    // 。。。。。。。。。。。。。无语
                    this.templateDescription = template.description
                    this.templateId = template.id
                    this.data = template.attrs
                    this.title = '编辑实体模板'
                }else{
                    this.editEntityTemplate = true
                    this.templateId = null
                    this.form = this.$form.createForm(this)
                    this.templateForm = this.$form.createForm(this)
                    this.data = []
                    this.title = '添加实体模板'
                }
            }
        }
    }
</script>